/**
 * Shared Theme Tokens
 * 
 * Common design tokens shared between light and dark themes.
 * These values remain constant across both themes.
 */

export const sharedTokens = {
  // Font Families
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  
  // Font Sizes
  fontSize: 14,
  fontSizeSM: 12,
  fontSizeLG: 16,
  fontSizeXL: 20,
  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16,
  
  // Font Weights
  fontWeightStrong: 600,
  
  // Line Heights
  lineHeight: 1.5715,
  lineHeightHeading1: 1.21,
  lineHeightHeading2: 1.27,
  lineHeightHeading3: 1.33,
  lineHeightHeading4: 1.4,
  lineHeightHeading5: 1.5,
  
  // Border Radius
  borderRadius: 6,
  borderRadiusLG: 8,
  borderRadiusSM: 4,
  borderRadiusXS: 2,
  
  // Spacing
  marginXS: 8,
  marginSM: 12,
  margin: 16,
  marginMD: 20,
  marginLG: 24,
  marginXL: 32,
  marginXXL: 48,
  
  paddingXS: 8,
  paddingSM: 12,
  padding: 16,
  paddingMD: 20,
  paddingLG: 24,
  paddingXL: 32,
  paddingXXL: 48,
  
  // Control Height
  controlHeight: 32,
  controlHeightLG: 40,
  controlHeightSM: 24,
  controlHeightXS: 16,
  
  // Motion
  motionDurationFast: '0.1s',
  motionDurationMid: '0.2s',
  motionDurationSlow: '0.3s',
  
  // Z-Index
  zIndexBase: 0,
  zIndexPopupBase: 1000,
  zIndexModalMask: 1000,
  zIndexModal: 1000,
  zIndexNotification: 1010,
  zIndexMessage: 1010,
  zIndexPopconfirm: 1060,
  zIndexTooltip: 1070,
};

/**
 * Semantic color names for consistent usage
 */
export const semanticColors = {
  primary: 'Primary brand color for main actions',
  success: 'Success states and positive feedback',
  warning: 'Warning states and cautionary information',
  error: 'Error states and destructive actions',
  info: 'Informational content and neutral feedback',
  link: 'Hyperlinks and clickable text',
};
